<template>
  <span>
    {{ spent | addComma('$') }}
  </span>
</template>

<script>
import addComma from '@/filters/addComma.js'

export default {
  filters: {
    addComma
  },
  computed: {
    spent () {
      return this.params.data && this.params.data.analytics ? this.params.data.analytics.spent : 0
    }
  }
}
</script>